import { EntityRepository } from '@record-it-npm/synchro-client';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';
import { AppEntityManagerEntityTypesByEntityName } from '../AppEntityManagerEntityTypesByEntityName';
import { TimeTrackingActivity } from './timeTrackingActivityTypes';
export class TimeTrackingActivityRepository extends EntityRepository<AppSynchronizationEnvironmentTypes, EntityName.TimeTrackingActivity, AppEntityManagerEntityTypesByEntityName> {
  public getByCompilationIdAndParentActivityId(compilationId: string, parentActivityId: string | null): Array<TimeTrackingActivity> {
    const activities = this.getAll().filter(a => a.compilationId === compilationId && a.parentActivityId === parentActivityId);
    return this.sortActivities(activities);
  }
  public getByUserGroupId(userGroupId: string): Array<TimeTrackingActivity> {
    const activities = this.getAll().filter(a => a.ownerUserGroupId === userGroupId);
    return this.sortActivities(activities);
  }
  public getByParentActivityId(parentActivityId: string): Array<TimeTrackingActivity> {
    const activities = this.getAll().filter(a => a.parentActivityId === parentActivityId);
    return this.sortActivities(activities);
  }
  public getPath(activityId: string): Array<TimeTrackingActivity | null> {
    const activity = this.getById(activityId);
    return [...(activity?.parentActivityId ? this.getPath(activity.parentActivityId) : []), activity];
  }
  private sortActivities(activities: Array<TimeTrackingActivity>): Array<TimeTrackingActivity> {
    return activities.sort((a, b) => a.order - b.order);
  }
}